/**
 * @title preauthchargesmodal.js: Sub-module for Global pages
 * @description This module is used to display the preauthcharges modal
 * @dependency 
 */
define(['dialog'], function(dialog) {	
	
	var preauthchargesmodal = {
			
		init : function() {
			this.attachExternalClass();
		},	 
    
	    attachExternalClass : function(){
			$('.preauthcharges-text').unbind().on('click', this.bind_external);
		},
	
	   	bind_external : function(event) {
	   		let callerElement = event.target;
	   		COSTCO.dialog.returnFocusOnCallerElement(callerElement);
			preauthchargesmodal.createDialogBox(this.href);
	   		event.preventDefault();
	   	},
	    
	    createDialogBox : function(url) {
	    	dialog.createExtDialogBox({
	    		title : messages.CHECKOUT_PREAUTH_MSG,
	    		body : COSTCO.util.tmpl('tmpl_preauthcharges_modal',{}),
	    		primary : messages.CLOSE
	    	});
	    }
		
	}
	
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.preauthchargesmodal = preauthchargesmodal;
		
	return preauthchargesmodal;
    
});


// WEBPACK FOOTER //
// ./js/checkout/preauthchargesmodal.js